import type { CallCategory } from "@expert/shared-types";
import type { UiMetadata } from "../logic-builder/types";

export const defaultUiMetadata: UiMetadata = {
    flowName: "Guide",
    closeConfirmation: {
        title: "Are you sure you’d like to close?",
        options: ["Didn’t work", "Other"],
    },
};

export const guidedFlowRecommendationMap: Partial<Record<CallCategory, string | undefined>> = {
    CONNECTIVITY_AND_NETWORK: "Connectivity & Network",
    DEVICE_ACTIVATION: "Device Activation",
    INSTALLATION_AND_SETUP: "Installation",
};
